/** @format */

import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const TicketInfo = ({ data }) => {
  const { t } = useTranslation();

  return (
    <div className="ticket-info">
      <div className="ticket-title">
        <p>
          <strong>{t('Tickets.caseTitle')}</strong>
        </p>
        <p>{data.title}</p>
      </div>
      <div className="ticket-description">
        <p>
          <strong>{t('Tickets.caseDescription')}</strong>
        </p>
        <p>{data.description}</p>
      </div>

      {/* Additional ticket details */}
      {data.project && (
        <div className="ticket-additional-field ticket-component">
          <p>
            <strong>{t('Tickets.component')}: </strong>
          </p>
          <p>
            {data.project}
            {data.subProject ? ` / ${data.subProject}` : ''}
          </p>
        </div>
      )}

      {data.ava_vrnnumber && (
        <div className="ticket-additional-field ticket-vrn">
          <p>
            <strong>{t('Tickets.vehicleRegistrationNumber')}: </strong>
          </p>
          <p>{data.ava_vrnnumber}</p>
        </div>
      )}

      {data.smy_affecteddriver && (
        <div className="ticket-additional-field ticket-affected-driver">
          <p>
            <strong>{t('Tickets.affectedDriver')}: </strong>
          </p>
          <p>{data.smy_affecteddriver}</p>
        </div>
      )}

      {data.smy_companycardnumber && (
        <div className="ticket-additional-field ticket-company-card">
          <p>
            <strong>{t('Tickets.companyCardNumber')}: </strong>
          </p>
          <p>{data.smy_companycardnumber}</p>
        </div>
      )}

      {data.smy_deviceserialnumber && (
        <div className="ticket-additional-field ticket-device-serial">
          <p>
            <strong>{t('Tickets.deviceSerialNumber')}: </strong>
          </p>
          <p>{data.smy_deviceserialnumber}</p>
        </div>
      )}
    </div>
  );
};
